import { useNavigate } from "react-router-dom";
import DataMartGrid from "../../components/DataMartGrid";
import type { DataMart } from "../../components/DataMartCard";
import styles from "./DataMarts.module.css";

const DATA_MARTS: DataMart[] = [
  {
    id: "account",
    name: "Account",
    description: "User accounts and permissions associated with law firm companies",
    tableCount: 1,
  },
  {
    id: "rankings",
    name: "Rankings",
    description: "Firm rankings by practice area, region, and tier from Legal 500 editorial data",
    tableCount: 1,
  },
  {
    id: "network-jurisdiction-rankings",
    name: "Network Jurisdiction Rankings",
    description: "Jurisdiction-level scores for law firm networks across countries and editions",
    tableCount: 1,
  },
  {
    id: "company-summaries",
    name: "Company Summaries",
    description:
      "Pre-built firm comparison summaries with rankings, ratings, testimonials, and offices",
    tableCount: 1,
  },
  {
    id: "intelligence",
    name: "Intelligence",
    description:
      "Mondaq intelligence articles, topics, regions, events, and guides synced from the Snowflake mart",
    tableCount: 12,
  },
];

function DataMartList() {
  const navigate = useNavigate();

  const handleDataMartClick = (dataMart: DataMart) => {
    navigate(`/data-marts/${dataMart.id}`);
  };

  return (
    <div className={styles.contentSection}>
      <DataMartGrid dataMarts={DATA_MARTS} onDataMartClick={handleDataMartClick} />
    </div>
  );
}

export default DataMartList;
